import React, { useEffect } from 'react'
import { animate, motion, useMotionValue, useTransform } from 'framer-motion'

export const AnimatedText = ({ children }: { children: string }): JSX.Element => {
  const count = useMotionValue(0)
  const rounded = useTransform(count, latest => Math.round(latest))
  const displayText = useTransform(rounded, latest => children.slice(0, latest))

  useEffect(() => {
    const controls = animate(count, children.length, {
      type: 'tween',
      duration: 1,
      delay: 0.3,
      ease: 'easeInOut'
    })

    return () => {
      controls.stop()
    }
  }, [count, children.length])

  return <motion.span>{displayText}</motion.span>
}
